import React, { useEffect, useCallback } from 'react'
import { Select, Table } from 'antd'
import { connect } from 'dva'
import { find } from 'lodash'
import PageWrapper from '@/components/PageWrapper'
import PageTable from '@/components/PageTable'
import './Gift.module.less'

const { Option } = Select
const { Column } = Table

const Gift = ({
  dispatch,
  giftType,
  giftPagination,
  giftData,
  giftStatues,
}) => {
  useEffect(() => {
    dispatch({
      type: 'center/getOrderList',
    })
    dispatch({
      type: 'center/getOrderStatues',
    })
  }, [dispatch])

  const handleChangeBugType = useCallback(
    (giftType) => {
      dispatch({
        type: 'center/save',
        payload: {
          giftType,
          giftPagination: {
            total: 0,
            current: 1,
            pageSize: giftPagination.pageSize,
          },
        },
      })
      dispatch({
        type: 'center/getOrderList',
      })
    },
    [dispatch, giftPagination]
  )

  const handleTableChange = (option) => {
    dispatch({
      type: 'center/save',
      payload: {
        giftPagination: {
          current: option.current,
          pageSize: option.pageSize,
          total: option.total,
        },
      },
    })
    dispatch({
      type: 'center/save',
      payload: {
        giftType,
      },
    })
    dispatch({
      type: 'center/getOrderList',
    })
  }

  const getLabel = useCallback(
    (id) => {
      const filter = find(giftStatues, (x) => x.id === id)
      return filter ? filter.name : ''
    },
    [giftStatues]
  )

  return (
    <PageWrapper
      subTitle={
        <div styleName="query-box">
          <span styleName="title">我获得的礼品：</span>
          <Select
            size="small"
            value={giftType}
            onChange={handleChangeBugType}
            style={{ width: '118px' }}
          >
            <Option value="">全部</Option>
            {giftStatues.map((it) => (
              <Option key={it.id} value={it.id}>
                {it.name}
              </Option>
            ))}
          </Select>
        </div>
      }
    >
      <div style={{ marginTop: '18px' }}>
        <PageTable
          onChange={handleTableChange}
          pagination={giftPagination}
          rowKey="id"
          dataSource={giftData}
          style={{ marginTop: '30px' }}
        >
          <Column title="商品名称" dataIndex="giftName" key="giftName" />
          <Column title="贡献币" dataIndex="goldCost" key="goldCost" />
          <Column
            title="订单状态"
            dataIndex="status"
            key="status"
            render={(text) => <span>{getLabel(text)}</span>}
          />
          <Column title="提交时间" dataIndex="createdAt" key="createdAt" />
        </PageTable>
      </div>
    </PageWrapper>
  )
}

export default connect(({ center }) => {
  return {
    giftType: center.giftType,
    giftPagination: center.giftPagination,
    giftData: center.giftData,
    giftStatues: center.giftStatues,
  }
})(Gift)
